import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import DropDown from '@/components/profile/dropDown'
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/basicDetails/constants"
import { capitalizeFirstLetter } from "@/utils"

import '@/pages/profile/sections/common.css'

export default function Gender(props: any) {
    const { common, profile } = useLocalTranslation();
    const genderOptions = [
        {
            value: common.statusText.male,
            label: capitalizeFirstLetter(common.statusText.male)
        },
        {
            value: common.statusText.female,
            label: capitalizeFirstLetter(common.statusText.female)
        }
    ];


    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <p className='commonH2'>
                {profile.fields.gender}
                <span className='text-[#FF2828]'>*</span>
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            <DropDown
                options={genderOptions}
                value={props.value}
                onChange={(e: any) => props.handleInputChange(e, listOfSections.gender)}
                placeholder={profile.placeHolders.selectYourGender}
                customDropDownIcon={true}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.gender)}
                />
            </div>
        </div>
    );
}
